import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _URLSearchParams from "@babel/runtime-corejs3/core-js-stable/url-search-params";
/**
 * Returns true if the path is a safe relative URL.
 * Rejects absolute URLs, protocol-relative paths (//), and backslash-relative
 * paths (/\) which browsers like Chrome and Safari normalize to // and treat
 * as external redirects.
 */
export var isSafeRelativePath = function isSafeRelativePath(path) {
  return _startsWithInstanceProperty(path).call(path, "/") && !_startsWithInstanceProperty(path).call(path, "//") && !_startsWithInstanceProperty(path).call(path, "/\\");
};
export var getRedirectUrl = function getRedirectUrl(doChangePassword, search) {
  if (doChangePassword) {
    return "/loginchangepassword";
  }
  var params = new _URLSearchParams(search);
  var nextLocation = params.get("next");
  if (nextLocation && isSafeRelativePath(nextLocation)) {
    return nextLocation;
  }
  return "/";
};

/**
 * Reads the ?next= query param from the current page URL and returns it if it
 * is a safe relative path, otherwise returns undefined. Used by SSO sign-in
 * handlers to pass next_url to the authorize endpoint.
 */
export var getSsoNextUrl = function getSsoNextUrl() {
  var params = new _URLSearchParams(window.location.search);
  var next = params.get("next");
  return next && isSafeRelativePath(next) ? next : undefined;
};